module.exports = __webpack_public_path__ + "static/media/mz.306bcd4e.svg";